import TabsNavigation from './TabsNavigation';

export default TabsNavigation;